import React from 'react';
import { Box, makeStyles, Typography } from "@material-ui/core";
import alertaStyles from "./Alerta.styles";
import EmergencyIcon from '../icons/EmergencyIcon';

const useStyles = makeStyles((theme) => ({
    alertBox: {
        ...alertaStyles.alertBox,
        justifyContent: 'space-between',
        gap: '1rem',
        backgroundColor: '#FCEEE7',
    },
    alertTitle: {
        ...alertaStyles.alertTitle,
        fontSize: '18px',
        fontWeight: 600,
    },
    alertSubtitle: {
        ...alertaStyles.alertSubtitle,
        fontSize: '12px',
        lineHeight: '18px',
    },
}));

const AlertaDevolucaoPendente = () => {
    const classes = useStyles();

    return (
        <Box className={classes.alertBox}>
            <EmergencyIcon color='errorMain' />
            <Box display={'flex'} flexDirection={'column'} flex={1}>
                <Typography variant="inherit" className={classes.alertTitle}>
                    A devolução foi confirmada sem o retorno de sucesso do código.
                </Typography>
                <Typography variant="caption" className={classes.alertSubtitle}>
                    Se a validação estiver demorando mais do que o normal, entre em contato com o SAL através do telefone (11) 99149-2204.
                </Typography>
                <Typography variant="caption" className={classes.alertSubtitle}>
                    Segunda a Sexta, das 09h às 21h e Sábado, das 09h às 19h.
                </Typography>
            </Box>

        </Box>
    );
};

export default AlertaDevolucaoPendente;